<template>
    <div>
        <div class="modal-overlay active"  @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 class="headline-s">Add Credit Card</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            
            <div class="modal__body flex-column">
                <div class="flex-row space-between">
                    <div class="input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText 
                                v-model="form.cc_name" 
                                id="cc_name" 
                                placeholder=" " 
                                required
                                :class="{'invalid-state-input': form.errors.cc_name}"
                            />
                            <label for="cc_name">
                                <p class="paragraph-default">Name on Card *</p>
                            </label>
                        </div>
                        <div class="input-folder">
                            <p class="input-support-text invalid-state" v-if="form.errors.cc_name"> {{ form.errors.cc_name}}</p>
                        </div>
                    </div>

                    <div class="input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText 
                                v-model="form.cc_alias" 
                                id="cc_alias" 
                                placeholder=" " 
                                required
                                :class="{'invalid-state-input': form.errors.cc_alias}"
                            />
                            <label for="cc_alias">
                                <p class="paragraph-default">Alias *</p>
                            </label>
                        </div>
                        <div class="input-folder">
                            <p class="input-support-text invalid-state" v-if="form.errors.cc_alias"> {{ form.errors.cc_alias}}</p>
                        </div>
                    </div>
                </div>
                
                <div class="flex-row space-between">
                <div class="input-folder">
                    <div class="input-folder--input">
                        <PrimeInputMask 
                            v-model="form.card_number"
                            id="card_number" 
                            placeholder=" " 
                            required
                            :class="{'invalid-state-input': form.errors.card_number}"
                            mask="9999 9999 9999 9?999 999"
                        />
                        <label for="card_number">
                            <p class="paragraph-default">Card Number *</p>
                        </label>
                    </div>
                    <div class="input-folder">
                        <p class="input-support-text invalid-state" v-if="form.errors.card_number"> {{ form.errors.card_number}}</p>
                    </div>
                </div>

                <div class="input-folder">
                    <div class="input-folder--input">
                        <PrimeInputMask 
                            v-model="form.cc_cvv"
                            id="cc_cvv" 
                            placeholder=" " 
                            required
                            :class="{'invalid-state-input': form.errors.cc_cvv}"
                            mask="999?9"
                        />
                        <label for="card_number">
                            <p class="paragraph-default">CVV *</p>
                        </label>
                    </div>
                    <div class="input-folder">
                        <p class="input-support-text invalid-state" v-if="form.errors.cc_cvv"> {{ form.errors.cc_cvv}}</p>
                    </div>
                </div>
                </div>

                <div class="input-folder">
                    <div class="input-folder--input">
                        <PrimeInputMask 
                            v-model="form.cc_exp" 
                            id="cc_exp" 
                            placeholder=" " 
                            required
                            :class="{'invalid-state-input': form.errors.cc_exp}"
                            mask="99/99"
                        />
                        <label for="cc_exp">
                            <p class="paragraph-default">Expiration Date * (MM/YY)</p>
                        </label>
                    </div>
                    <div class="input-folder">
                        <p class="input-support-text invalid-state" v-if="form.errors.cc_exp"> {{ form.errors.cc_exp}}</p>
                    </div>
                </div>

                
                <div class="flex-row space-between">
                    <div class="input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText 
                                v-model="form.cc_street" 
                                id="cc_street" 
                                placeholder=" " 
                                required
                                :class="{'invalid-state-input': form.errors.cc_street}"
                            />
                            <label for="cc_street">
                                <p class="paragraph-default">Street *</p>
                            </label>
                        </div>
                        <div class="input-folder">
                            <p class="input-support-text invalid-state" v-if="form.errors.cc_street"> {{ form.errors.cc_street}}</p>
                        </div>
                    </div>

                    <div class="input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText 
                                v-model="form.cc_city" 
                                id="cc_city" 
                                placeholder=" " 
                                required
                                :class="{'invalid-state-input': form.errors.cc_city}"
                            />
                            <label for="cc_city">
                                <p class="paragraph-default">City {{ requireStateCity ? '*' : '' }}</p>
                            </label>
                        </div>
                        <div class="input-folder">
                            <p class="input-support-text invalid-state" v-if="form.errors.cc_city"> {{ form.errors.cc_city}}</p>
                        </div>
                    </div>
                </div>
                
                <div class="flex-row space-between">
                    <div class="input-folder">
                        <div v-if="!formattedRegions" class="input-folder--input">
                            <PrimeInputText 
                                v-model="form.cc_state" 
                                id="cc_state" 
                                placeholder=" " 
                                required
                                :class="{'invalid-state-input': form.errors.cc_state}"
                            />
                            <label for="cc_state">
                                <p class="paragraph-default">State {{ requireStateCity ? '*' : '' }}</p>
                            </label>
                        </div>
                        <custom-select
                            v-else
                            v-model="selectedRegion"
                            :label="`State ${requireStateCity ? '*' : ''}`"
                            name="cc_state"
                            id="cc_state"
                            aria-label="Enter State"
                            :options="formattedRegions"
                        />
                        <div class="input-folder">
                            <p class="input-support-text invalid-state" v-if="form.errors.cc_state"> {{ form.errors.cc_state}}</p>
                        </div>
                    </div>
                    <div class="input-folder">
                    <div class="input-folder--input">
                        <PrimeInputText 
                            v-model="form.cc_zip" 
                            id="cc_zip" 
                            placeholder=" " 
                            required
                            :class="{'invalid-state-input': form.errors.cc_zip}"
                        />
                        <label for="cc_zip">
                            <p class="paragraph-default">Zip Code {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder">
                        <p class="input-support-text invalid-state" v-if="form.errors.cc_zip"> {{ form.errors.cc_zip}}</p>
                    </div>
                </div>

                    
                </div>
                
                <div class="input-folder">
                        <custom-select 
                            v-model="selectedCountry"
                            label="Country *"
                            name="cc_country"
                            id="cc_country"
                            aria-label="Enter Country"
                            :options="formattedCountries"
                        />
                        <div class="input-folder">
                            <p class="input-support-text invalid-state" v-if="form.errors.cc_country"> {{ form.errors.cc_country}}</p>
                        </div>

                    </div>

                <p class="invalid-state paragraph-default" v-if="form.errors.message">{{ form.errors.message }}</p>
                <div class="flex-row justify-end">
                    <RothcoCta :disabled="form.processing" id="submitButton" :class="formValid ? `primary` : `disabled`" @click="submit">Add Credit Card</RothcoCta>
                </div>
            </div>
        </div>
    </div>

    <!--  -->
</template>
<script lang="ts" setup>
import { watch, computed, ref, nextTick, inject } from "vue";
// import { route } from "ziggy-js";
import { useForm } from "@/helpers/composables/useForm";
import { object, string, number } from "yup";
import { useFocus } from "@vueuse/core";
import RothcoCta from "@/components/RothcoCta.vue";
import { useSettingsStore } from "@/store/settings";
let { setNotificationMessage } = useSettingsStore();
let modelValue = defineModel();
let dialogRef = inject("dialogRef");
import CloseIcon from "@icons/closeIcon.svg";
let companyId = computed(() => {
    return dialogRef.value.data.companyId;
});

const closeDialog = function (data=null) {
    form.reset();
    dialogRef?.value?.close(data);
};

let formValid = computed(() => {
    let fields = [
        "cc_name",
        'cc_cvv',
        "card_number",
        "cc_exp",
        "cc_alias",
        "cc_street",
        "cc_city",
        "cc_state",
        "cc_country",
        "cc_zip"
    ];

    return fields.every((field) => !form.errors[field]);
});

let form = useForm({
    useInertia: false,
    schema: object({
        company_id: number(),
        cc_exp: string()
            .required()
            .test({
                name: "cc_exp",
                message: "Invalid expiration date",
                test: (value) => {
                    if (value) {
                        const [month, year] = value.split("/");
                        const now = new Date();
                        const exp = new Date(`20${year}`, month);
                        return exp > now;
                    }
                    return false;
                }
            }),
        cc_type: string().required(),
        card_number: string()
            .required("Card number is required")
            .test({
                name: "card_number",
                message: "Invalid card number",
                test: (value) => {
                    return luhnCheck(value);
                }
            }),
        cc_cvv: string()
            .required("CVV is required")
            .test({
                name: "cc_cvv",
                message: "Invalid CVV",
                test: (value) => {
                    return value.length >= 3 && value.length <= 4;
                }
            }),
        cc_name: string().required("Name on card is required").default(""),
        cc_street: string().required("Street is required").default(""),
        cc_city: string().optional().test(
            'is-not-empty',
            'City is required',
            (value) => {
                if(form.cc_country == 'USA' || form.cc_country == 'CAN'){
                    return  value !== undefined && value !== '' && value !== null;
                }
                return true;
            }
        ).default(""),
        cc_state: string().optional().test(
            'is-not-empty',
            'State is required',
            (value) => {
                if(form.cc_country == 'USA' || form.cc_country == 'CAN'){
                    return  value !== undefined && value !== '' && value !== null;
                }
                return true;
            }
        ).default(""),
        cc_country: string().required("Country is required").default(""),
        cc_zip: string()
            .optional()
            .test({
                name: "cc_zip",
                message: "Please enter a valid Zip Code",
                test: (value) => {
                    if(form.cc_country == 'USA' || form.cc_country == 'CAN'){
                        return /^(?:\d{5}(?:-\d{4})?|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d|[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}|GIR 0AA)$/.test(
                            value
                        );
                    }
                    return true;
                }
            })
            .default(""),
        cc_alias: string().required("Alias is required").default("")
    })
});
const luhnCheck = function (cardNumber) {
    cardNumber = cardNumber.replace(/\D/g, "");
    let sum = 0;
    let numDigits = cardNumber.length;
    let parity = numDigits % 2;
    for (let i = 0; i < numDigits; i++) {
        let digit = parseInt(cardNumber.charAt(i));
        if (i % 2 == parity) digit *= 2;
        if (digit > 9) digit -= 9;
        sum += digit;
    }
    return sum % 10 == 0;
};

const cardType = computed(() => {
    if (form.card_number) {
        if (form.card_number.match(/^4/)) {
            return "Visa";
        } else if (form.card_number.match(/^5[1-5]/)) {
            return "MasterCard";
        } else if (form.card_number.match(/^3[47]/)) {
            return "American Express";
        } else if (form.card_number.match(/^6(?:011|5)/)) {
            return "Discover";
        }
    }
    return "Unknown";
});
const ccCardKey = ref(0);

const requireStateCity = computed(()=>{
    return !!form.cc_country && ['USA','CAN'].includes(form.cc_country);
})

let formattedCountries = computed(()=>{
    return dialogRef?.value?.data?.countries?.map((country)=>{
        return {
            value: country.name,
            key: country.alpha3code
        }
    }) ?? [];
})
let selectedCountry = computed({
    get(){
        return formattedCountries.value.find(currentCountry => currentCountry.key == form.cc_country) ?? {key: '', value: ''};
    },
    set(value){
        form.cc_country = value.key;
    }
})
const CANADA_STATE_CODES = new Set(['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']);
let formattedRegions = computed(()=>{
    const regions = dialogRef?.value?.data?.regions ?? [];
    const countryRegionMap = {
        'CAN': regions
            .filter(region => CANADA_STATE_CODES.has(region.code) && region.code !== 'PR')
            .map(region => ({ key: region.code, value: region.name })),
        'PRI': [{ key: 'PR', value: 'Puerto Rico' }],
        'USA': regions
            .filter(region => !CANADA_STATE_CODES.has(region.code))
            .map(region => ({ key: region.code, value: region.name }))
    };
    return countryRegionMap[form.cc_country] ?? null;
})
let selectedRegion = computed({
    get(){
        return formattedRegions.value.find(currentRegion => currentRegion.key == form.cc_state) ?? {key: '', value: ''};
    },
    set(newVal){
        form.cc_state = newVal.key;
    }
})

watch(() => form.cc_country, (newCountryValue, oldCountryValue) => {
    if (!['USA', 'CAN', 'PRI'].includes(newCountryValue) && ['USA', 'CAN', 'PRI'].includes(oldCountryValue)) {
        form.cc_state = '';
        return;
    }
    if (['USA', 'CAN', 'PRI'].includes(newCountryValue)) {
        let state = form.cc_state?.toLowerCase();
        let availableStates = formattedRegions.value || [];

        let matchedState = availableStates.find(
            s => s.value?.toLowerCase() === state || s.key?.toLowerCase() === state
        );
        form.cc_state = matchedState ? matchedState.key : '';
    }
});

async function submit () {
    if(form.processing) return;
    
    form.cc_type = cardType.value
    form.cc_last_4 = form.card_number?.slice?.(-4);
    await form.validate({ all: true });
    if(Object.keys(form.errors).length > 0) return;
    if(!['MasterCard', 'Master Card', 'Visa'].includes(form.cc_type)){
        setNotificationMessage({
            type: 'error',
            message: 'Only Visa and Master Card are accepted for dealers'
        });
        return;
    }
    await nextTick();
    form.post(
        route("endpoints.creditcards.store"),
        {
            credit_card: form.transform((data) => ({
                ...data,
                company_id: companyId.value,
                card_number: data.card_number?.replace?.(/\s/g, ""),
                cc_exp: data.cc_exp?.replace?.("/", "")
            }))
        },
        {
            afterFetch: (response) => {
                modelValue.value = false;
                setNotificationMessage({
                    message: "Credit Card added successfully!",
                    type: "success"
                });
                closeDialog({
                    new_credit_card_id: response.data.credit_card_id
                });
            },
            onFetchError: (err)=>{
                setNotificationMessage({
                    message: "There was an issue with your request, please try again.",
                    type: "error"
                });
            }
        }
    );
};
</script>
